export default __webpack_public_path__ + "cff89cfd2847dedf76d5154a18736169.png";